/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfDocumentFileDto } from "../models/AjaxResponseOfDocumentFileDto";
import type { AjaxResponseOfListOfDocumentFileDto } from "../models/AjaxResponseOfListOfDocumentFileDto";
import type { VehicleFileNameUpdateInput } from "../models/VehicleFileNameUpdateInput";
import type { VehicleFilesBatchUploadArgs } from "../models/VehicleFilesBatchUploadArgs";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class VehicleDocumentAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfListOfDocumentFileDto
   * @throws ApiError
   */
  public getAll({
    vehicleId,
  }: {
    vehicleId: string;
  }): CancelablePromise<AjaxResponseOfListOfDocumentFileDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-documents/{vehicleId}/todos",
      path: {
        vehicleId: vehicleId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfDocumentFileDto
   * @throws ApiError
   */
  public getById({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfDocumentFileDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-documents/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: Array<VehicleFilesBatchUploadArgs>;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-documents",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfListOfDocumentFileDto
   * @throws ApiError
   */
  public update({
    requestBody,
  }: {
    requestBody?: Array<VehicleFileNameUpdateInput>;
  }): CancelablePromise<AjaxResponseOfListOfDocumentFileDto> {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/front-end/v1/vehicle-documents",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({
    amznS3Ids,
  }: {
    amznS3Ids?: Array<string>;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/vehicle-documents",
      query: {
        amznS3Ids: amznS3Ids,
      },
    });
  }
}
